import { createFileRoute } from '@tanstack/react-router';

import { MilestonesPage } from '@/features/plan/milestones-page';

export const Route = createFileRoute('/_app/projects/$projectId/plan/milestones')({
  component: MilestonesRoute,
});

function MilestonesRoute() {
  const { projectId } = Route.useParams();
  return <MilestonesPage projectId={projectId} />;
}
